"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSDKVersion = void 0;
const sdk_js_1 = __importDefault(require("./sdk.js"));
exports.default = sdk_js_1.default;
__exportStar(require("./sdk.js"), exports);
__exportStar(require("./types/index.js"), exports);
__exportStar(require("./communication/methods.js"), exports);
__exportStar(require("./communication/messageFormatter.js"), exports);
var version_js_1 = require("./version.js");
Object.defineProperty(exports, "getSDKVersion", { enumerable: true, get: function () { return version_js_1.getSDKVersion; } });
__exportStar(require("./eth/constants.js"), exports);
//# sourceMappingURL=index.js.map